<template>

    <section>
        <div class="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 p-1.5">

            <div v-for="(image, index) in images" :key="index">
                <div class="p-1.5">
                    <nuxt-img width="340" height="30" format="webp" :src="image.src" :alt="image.alt" class="w-full"
                        loading="lazy" sizes="xs:110px sm:140px md:177px lg:157px xl:231px" />
                        </div>
                </div>
          
              


          
        </div>
    </section>

</template>

<script setup>

const images = ref([
    {
        src: '/assets/images/customer-img-1.jpg',
        alt: 'section image',
    },
    {
        src: '/assets/images/customer-img-2.jpg',
        alt: 'section image',
    },
    {
        src: '/assets/images/customer-img-3.jpg',
        alt: 'section image',
    },
    {
        src: '/assets/images/customer-img-4.jpg',
        alt: 'section image',
    },
    {
        src: '/assets/images/customer-img-5.png',
        alt: 'section image',
    },
    {
        src: '/assets/images/customer-img-6.jpg',
        alt: 'section image',
    },

    // Add more images as needed
]);


defineBuilderComponent({
    friendlyName: 'CustomersImages',
    ignored: true
})
</script>